import { useCustomSearchParams } from 'hooks/useCustomSearchParams';
import { useGetOrdersByLocaleStatistic } from 'api/statisticApi';
import ColumnChart from '../../ColumnChart';

export default function StatisticOrderQuantityByLocale() {
  const [search] = useCustomSearchParams();
  const { data, isLoading } = useGetOrdersByLocaleStatistic({ params: search });

  if (isLoading) {
    return null;
  }

  return <ColumnChart title="Số lượng Order theo quốc gia" data={data} />;
}
